import {FC} from "react";

import {Route, Routes} from "react-router-dom";
import {HomePage} from "./pages";
import styled from "styled-components";
import {Column} from "./styles/common";

const Container = styled(Column)`
  width: calc(var(--vw, 1vw) * 100);
  height: calc(var(--vh, 1vh) * 100);
  min-height: calc(var(--vh, 1vh) * 100);
  max-width: calc(var(--vw, 1vw) * 100);
`;

const AppContent: FC = () => {
  return (
    <Container>
      <Routes>
        <Route path="/:code" element={<HomePage />} />
      </Routes>
    </Container>
  );
};

export default AppContent;
